import { render, staticRenderFns } from "./BlogMainWrapper.vue?vue&type=template&id=5971b3dc&scoped=true&"
import script from "./BlogMainWrapper.vue?vue&type=script&lang=js&"
export * from "./BlogMainWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5971b3dc",
  null
  
)

export default component.exports